import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about">
      <Header />

      <main className="about-content">
        <section className="hero-section">
          <img src="/main/a1.jpeg" alt="Our story" className="hero-bg" />
          <h1 className="hero-title">our story</h1>
        </section>

        <section className="experience-section">
          <h2>live the experience</h2>
          <p>
            Parkhaven is more than apparel—it's an invitation to live the
            experience. Every piece we create is a balance of style and
            functionality, crafted with care for both people and planet. We hold
            ourselves to the highest standards of transparency and
            accountability, so you can feel confident in what you wear and why
            you wear it. Because for us, movement is more than motion. It's how
            we connect, explore, and keep becoming—breath by breath, stride by
            stride.
          </p>
        </section>

        <section className="roots-section">
          <div className="roots-images">
            <img
              src="/main/a2.png"
              alt="Meditation in water"
              className="root-img-1"
            />
          </div>
          <div className="roots-text">
            <h2>our roots</h2>
            <p>
              In 1992, Beaver and Pam Theodosakis set out on a journey to make
              sustainable and stylish fashion for those who live active
              lifestyles.
            </p>
            <p>
              And from those days of assembling each piece by hand in their
              garage, using fruit crates to transport products, and cutting hang
              tags from repurposed paper, we've come a long way. But throughout
              it all, our vision, values, and culture have held strong—still
              rooted back to that small garage in Carlsbad, California,
              following our mission to make clothing with a higher purpose.
            </p>
          </div>
        </section>

        <section className="meaning-section">
          <div className="meaning-text">
            <h2>what does Parkhaven mean?</h2>
            <p className="main-desc">
              The word Parkhaven comes from Sanskrit. It means breath, and is
              considered the life-giving force, the universal energy that flows
              within and among us, connecting us with all other living beings.
            </p>
            <div className="definition">
              <p>pra·na /'prän /</p>
              <p>noun | Hinduism</p>
              <p>Breath, a life-giving force.</p>
            </div>
          </div>
          <div className="meaning-image">
            <img src="/main/a3.png" alt="Two people playing in a field" />
          </div>
        </section>

        <section className="in-real-life-section">
          <h2>in real life</h2>
          <p>
            Check out our community events page{" "}
            <Link onClick={toTop} to="/">
              here.
            </Link>
          </p>
        </section>

        <section className="intentionally-built-section">
          <div className="built-image">
            <img src="/main/a5.jpeg" alt="Ocean waves and birds" />
          </div>
          <div className="built-text">
            <h2>intentionally built</h2>
            <p>
              Since 1992 we've been on a journey to nurture a positive impact
              through the way we operate. Our clothing is built for durability
              with the people and planet in mind, so you can feel good about
              investing in long-wearing style that endures.
            </p>
            <p>
              Learn more about our sustainability pillars{" "}
              <Link onClick={toTop} to="/">
                here.
              </Link>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
